import WebError from "./WebError";

export default class NotFoundWebError extends WebError {
  constructor(code?: number, message?: string) {
    super(404, code, message);
    this.name = 'Not Found';
  }
}
